<app-esqueleto-tableros>
  <div titulo class="encabezadosSeparacion"
    [matTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)"
    [appOverflowTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>

  <app-filters filtros
    [array]="aniosDisponibles"
    [typeFilter]="Filtros.YEAR"
    [name]="'filtros.anio' | translate"
    (eventClick)="anioChange($event)"
    [click]="false"
  />
  <app-filters filtros
    [array]="mesesDisponibles"
    [typeFilter]="Filtros.MOUNTH"
    [name]="'filtros.mes' | translate"
    (eventClick)="mesChange($event)"
    [click]="false"
  />

  <div contenido class="workSpaceTab">
    <div class="zonaChips" [ngClass]="{'w3-disabled': cargando || descargando}">

      <div class="togElement">
        <div class="tituloGrupo" style="width: 13vw; font-weight: 600;">{{'financiero.reporte.menu-balance-general' | translate}}</div>
      </div>
      <div class="togElement">
        <mat-slide-toggle labelPosition="before" [(ngModel)]="balanceEstructuraA">
          <div style="width: 13vw; padding-left: 1vw;">{{'financiero.reporte.menu-bg-estructura' | translate}}</div>
        </mat-slide-toggle>
      </div>
      @if (balanceEstructuraA) {
        <div class="togElement subModuloOculto">
          <mat-slide-toggle labelPosition="before" [(ngModel)]="activoA">
            <div style="width: 13vw; padding-left: 1vw;">{{'financiero.reporte.estructura-activo' | translate}}</div>
          </mat-slide-toggle>
        </div>
        <div class="togElement subModuloOculto">
          <mat-slide-toggle labelPosition="before" [(ngModel)]="pasivoA">
            <div style="width: 13vw; padding-left: 1vw;">{{'financiero.reporte.estructura-pasivo' | translate}}</div>
          </mat-slide-toggle>
        </div>
        <div class="togElement subModuloOculto">
          <mat-slide-toggle labelPosition="before" [(ngModel)]="patrimonioA">
            <div style="width: 13vw; padding-left: 1vw;">{{'financiero.reporte.estructura-patrimonio' | translate}}</div>
          </mat-slide-toggle>
        </div>
        <mat-divider class="separador subModuloOculto"></mat-divider>
      }

      <div class="togElement">
        <mat-slide-toggle labelPosition="before" [(ngModel)]="balanceTendenciaA">
          <div style="width: 13vw; padding-left: 1vw;">{{'financiero.reporte.menu-bg-tendencia' | translate}}</div>
        </mat-slide-toggle>
      </div>
      @if (balanceTendenciaA) {
        <div class="togElement subModuloOculto">
          <mat-slide-toggle labelPosition="before" [(ngModel)]="carteraNetaA">
            <div style="width: 13vw; padding-left: 1vw;">{{'financiero.reporte.cartera-neta' | translate}}</div>
          </mat-slide-toggle>
        </div>
        <mat-divider class="separador subModuloOculto"></mat-divider>
      }

      <div class="togElement">
        <div class="tituloGrupo" style="width: 13vw; font-weight: 600;">{{'financiero.reporte.menu-estado-resultados' | translate}}</div>
      </div>
      <div class="togElement">
        <mat-slide-toggle labelPosition="before" [(ngModel)]="estadoResultadosA">
          <div style="width: 13vw; padding-left: 1vw;">{{'financiero.reporte.menu-er-estructura' | translate}}</div>
        </mat-slide-toggle>
      </div>
      @if (estadoResultadosA) {
        <div class="togElement subModuloOculto">
          <mat-slide-toggle labelPosition="before" [(ngModel)]="estructuraCostosA">
            <div style="width: 13vw; padding-left: 1vw;">{{'financiero.reporte.estructura-costos' | translate}}</div>
          </mat-slide-toggle>
        </div>
        <div class="togElement subModuloOculto">
          <mat-slide-toggle labelPosition="before" [(ngModel)]="tendenciaCostosA">
            <div style="width: 13vw; padding-left: 1vw;">{{'financiero.reporte.tendencia-costos' | translate}}</div>
          </mat-slide-toggle>
        </div>
        <mat-divider class="separador subModuloOculto"></mat-divider>
      }

      <div class="togElement">
        <mat-slide-toggle labelPosition="before" [(ngModel)]="indicadoresA">
          <div style="width: 13vw; font-weight: 600;">{{'financiero.reporte.menu-indicadores' | translate}}</div>
        </mat-slide-toggle>
      </div>
      @if (indicadoresA) {
        @for (bloque of bloquesIndicadores; track bloque.clave) {
          <div class="togElement subModuloOculto">
            <mat-slide-toggle labelPosition="before" [(ngModel)]="bloque.activo">
              <div style="width: 13vw; padding-left: 1vw;">{{'financiero.reporte.' + bloque.clave | translate}}</div>
            </mat-slide-toggle>
          </div>
        }
        <mat-divider class="separador subModuloOculto"></mat-divider>
      }

      <div class="togElement">
        <mat-slide-toggle labelPosition="before" [(ngModel)]="conclusionesA">
          <div style="width: 13vw; font-weight: 600;">{{'financiero.reporte.menu-conclusiones' | translate}}</div>
        </mat-slide-toggle>
      </div>

    </div>

    <div class="zonaVisualizacion">
      @if (!cargando) {
        <div class="preview-background">
          <section class="page">
            <div class="pageName">
              {{'financiero.reporte.portada-1' | translate}}
            </div>
            <p>{{'financiero.reporte.introduccion' | translate:{institucion: nombreInstitucion, periodo: periodoTexto} }}</p>
            <div class="pageName" style="margin-top: 4vh;">
              <span class="mayusculas">{{'financiero.reporte.' + claveTituloAnalisis | translate:parametrosReporte}}</span>
            </div>
            <p>{{'financiero.reporte.' + claveIntroAnalisis | translate:parametrosReporte}}</p>
            @if (balanceEstructuraA) {
              <h2 style="margin-top: 2vh;">{{'financiero.reporte.bg-estructura-titulo' | translate}}</h2>
              <p>{{'financiero.reporte.bg-estructura-def' | translate}}</p>
              @if (cargandoBalance) {
                <app-skeleton-table [columnas]="6" [filas]="13"/>
              } @else if (filasBalance.length > 0) {
                <div class="w3-scroll">
                  <table class="w3-table borderInf">
                    <thead style="background-color: #A7A9AC;">
                      <tr class="w3-table-titleBalance">
                        <th class="w3-elemento-titulo-table w3-center w3-border-right-balance">{{'financiero.catalogoCuentas.encabezado2Tabla1' | translate}}</th>
                        @for (col of columnasBalance; track col.id) {
                          <th class="w3-elemento-titulo-table w3-border-right-balance" style="text-align: left;">{{col.titulo}}</th>
                          <th class="w3-elemento-titulo-table w3-center textColorN1 w3-border-right-balance">%</th>
                        }
                      </tr>
                    </thead>
                    <tbody>
                      @for (fila of filasBalance; track $index) {
                        <tr [ngClass]="{'w3-table-trtdBalanceBlue w3-encabezado-balance': fila.nivel === 1, 'w3-table-trtdBalance w3-cuerpo-balance': fila.nivel !== 1}">
                          <td class="borderAllLow" [ngClass]="fila.nivel === 1 ? 'w3-elemento-titulo-tableBalance w3-encabezado-balance' : 'w3-elemento-tableBalance'">
                            <span [style.margin-left.rem]="(fila.nivel - 1) * 1.2">{{fila.descripcion}}</span>
                          </td>
                          @for (valor of fila.valores; track $index) {
                            <td class="alinRight borderAllLow" [ngClass]="fila.nivel === 1 ? 'w3-elemento-titulo-tableBalance w3-encabezado-balance' : 'w3-elemento-tableBalance'">
                              @if (valor !== null) {
                                <span style="margin-right: 5%;">{{valor | formaterNumber:0:miles:decimal}}</span>
                              }
                            </td>
                            <td class="w3-center borderAllLow" [ngClass]="'textColorN' + fila.nivel">
                              @if (valor !== null) {
                                <span>{{fila.porcentajes[$index] | formaterNumber:0:miles:decimal}} %</span>
                              }
                            </td>
                          }
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              }
              @for (g of graficasEstructura; track g.zona) {
                @if (graficaVisible(g)) {
                  <h3 [style.text-align]="g.dona === 'derecha' ? 'right' : 'left'">{{'financiero.reporte.' + g.clave | translate}}</h3>
                  <div class="bloqueDona" [ngClass]="{'invertido': g.dona === 'derecha'}">
                    <div class="zonaGraf donaGraf">
                      <app-graficador
                      [etiquetas]="true"
                      [data]="g.data"
                      [labels]="g.labels"
                      [type]="tipoDona"
                      [axisX]="''"
                      [axisY]="['']"
                      [zona]="g.zona"
                      [colors]="colorMulti"
                      [porcentaje]="true"
                      [changeLabel]="false"
                      [legend]="legendDona"
                      ></app-graficador>
                    </div>
                    <div class="textoDona">
                      @for (texto of g.textos; track $index) {
                        <p>@for (parte of partesTexto(texto); track $index) {<span [class.textoNegativo]="parte.negativo">{{parte.texto}}</span>}</p>
                      }
                    </div>
                  </div>
                }
              }
            }
          </section>
          <br>


          @if (balanceTendenciaA) {
            <section class="page pageHorizontal">
              <h2 style="margin-top: 2vh;">{{'financiero.reporte.bg-tendencia-titulo' | translate}}</h2>
              <p>{{'financiero.reporte.bg-tendencia-def' | translate}}</p>
              @if (cargandoBalance) {
                <app-skeleton-table [columnas]="8" [filas]="13"/>
              } @else if (filasTendencia.length > 0 && paresTendencia.length > 0) {
                <div class="w3-scroll">
                  <table class="w3-table borderInf">
                    <thead style="background-color: #A7A9AC;">
                      <tr class="w3-table-titleBalance">
                        <th [attr.colspan]="columnasBalance.length + 1" style="background-color: #FFFFFF;"></th>
                        @for (par of paresTendencia; track $index) {
                          <th colspan="2" class="w3-elemento-titulo-table w3-center w3-border-right-balance" style="background-color: #E0E1E3;">{{par}}</th>
                        }
                      </tr>
                      <tr class="w3-table-titleBalance">
                        <th class="w3-elemento-titulo-table w3-center w3-border-right-balance">{{'financiero.catalogoCuentas.encabezado2Tabla1' | translate}}</th>
                        @for (col of columnasBalance; track col.id) {
                          <th class="w3-elemento-titulo-table w3-border-right-balance" style="text-align: left;">{{col.titulo}}</th>
                        }
                        @for (par of paresTendencia; track $index) {
                          <th class="w3-elemento-titulo-table w3-center textColorN1 w3-border-right-balance">{{'financiero.reporte.tendencia-variacion' | translate}}</th>
                          <th class="w3-elemento-titulo-table w3-center textColorN1 w3-border-right-balance">%</th>
                        }
                      </tr>
                    </thead>
                    <tbody>
                      @for (fila of filasTendencia; track $index) {
                        <tr [ngClass]="{'w3-table-trtdBalanceBlue w3-encabezado-balance': fila.nivel === 1, 'w3-table-trtdBalance w3-cuerpo-balance': fila.nivel !== 1}">
                          <td class="borderAllLow" [ngClass]="fila.nivel === 1 ? 'w3-elemento-titulo-tableBalance w3-encabezado-balance' : 'w3-elemento-tableBalance'">
                            <span [style.margin-left.rem]="(fila.nivel - 1) * 1.2">{{fila.descripcion}}</span>
                          </td>
                          @for (valor of fila.valores; track $index) {
                            <td class="alinRight borderAllLow" [ngClass]="fila.nivel === 1 ? 'w3-elemento-titulo-tableBalance w3-encabezado-balance' : 'w3-elemento-tableBalance'">
                              @if (valor !== null) {
                                <span style="margin-right: 5%;">{{valor | formaterNumber:0:miles:decimal}}</span>
                              }
                            </td>
                          }
                          @for (variacion of fila.variaciones; track $index) {
                            <td class="alinRight borderAllLow" [ngClass]="'textColorN' + fila.nivel">
                              @if (variacion.valor !== null) {
                                <span style="margin-right: 5%;">{{variacion.valor | formaterNumber:0:miles:decimal}}</span>
                              }
                            </td>
                            <td class="w3-center borderAllLow" [ngClass]="'textColorN' + fila.nivel">
                              @if (variacion.valor !== null) {
                                <span>{{variacion.porcentaje | formaterNumber:0:miles:decimal}} %</span>
                              }
                            </td>
                          }
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              }
              @if (!cargandoBalance) {
                @for (texto of textosTendencia; track $index) {
                  <p class="textoHorizontal">@for (parte of partesTexto(texto); track $index) {<span [class.textoNegativo]="parte.negativo">{{parte.texto}}</span>}</p>
                }
              }
            </section>
            <br>
            @if (carteraNetaA) {
            <section class="page pageCompacta">
              <h3>{{'financiero.reporte.cartera-neta' | translate}}</h3>
                @if (opcionesCartera) {
                  <div class="zonaGraf zonaGrafAlta">
                    <apx-chart
                      [series]="opcionesCartera.series"
                      [chart]="opcionesCartera.chart"
                      [colors]="opcionesCartera.colors"
                      [plotOptions]="opcionesCartera.plotOptions"
                      [dataLabels]="opcionesCartera.dataLabels"
                      [grid]="opcionesCartera.grid"
                      [xaxis]="opcionesCartera.xaxis"
                      [yaxis]="opcionesCartera.yaxis"
                      [legend]="opcionesCartera.legend"
                      [tooltip]="opcionesCartera.tooltip"
                    ></apx-chart>
                  </div>
                }
                @if (!cargandoBalance) {
                  @for (texto of textosCartera; track $index) {
                    <p>@for (parte of partesTexto(texto); track $index) {<span [class.textoNegativo]="parte.negativo">{{parte.texto}}</span>}</p>
                  }
                }
            </section>
            <br>
            }
          }

          @if (estadoResultadosA) {
            <section class="page">
              <h2 style="margin-top: 2vh;">{{'financiero.reporte.er-estructura-titulo' | translate}}</h2>
              <p>{{'financiero.reporte.er-estructura-def' | translate:parametrosReporte}}</p>
              @if (cargandoBalance) {
                <app-skeleton-table [columnas]="6" [filas]="13"/>
              } @else if (filasEstado.length > 0) {
                <div class="w3-scroll">
                  <table class="w3-table borderInf">
                    <thead style="background-color: #A7A9AC;">
                      <tr class="w3-table-titleBalance">
                        <th class="w3-elemento-titulo-table w3-center w3-border-right-balance">{{'financiero.catalogoCuentas.encabezado1Tabla1' | translate}}</th>
                        <th class="w3-elemento-titulo-table w3-center w3-border-right-balance">{{'financiero.catalogoCuentas.encabezado2Tabla1' | translate}}</th>
                        @for (col of columnasBalance; track col.id) {
                          <th class="w3-elemento-titulo-table w3-border-right-balance" style="text-align: left;">{{col.titulo}}</th>
                          <th class="w3-elemento-titulo-table w3-center textColorN1 w3-border-right-balance">%</th>
                        }
                      </tr>
                    </thead>
                    <tbody>
                      @for (fila of filasEstado; track $index) {
                        <tr [ngClass]="{'w3-table-trtdBalanceBlue w3-encabezado-balance': fila.nivel === 1, 'w3-table-trtdBalance w3-cuerpo-balance': fila.nivel !== 1}">
                          <td class="borderAllLow" [ngClass]="fila.nivel === 1 ? 'w3-elemento-titulo-tableBalance w3-encabezado-balance' : 'w3-elemento-tableBalance'">{{fila.id}}</td>
                          <td class="borderAllLow" [ngClass]="fila.nivel === 1 ? 'w3-elemento-titulo-tableBalance w3-encabezado-balance' : 'w3-elemento-tableBalance'">
                            <span [style.margin-left.rem]="(fila.nivel - 1) * 1.2">{{fila.descripcion}}</span>
                          </td>
                          @for (valor of fila.valores; track $index) {
                            <td class="alinRight borderAllLow" [ngClass]="fila.nivel === 1 ? 'w3-elemento-titulo-tableBalance w3-encabezado-balance' : 'w3-elemento-tableBalance'">
                              @if (valor !== null) {
                                <span style="margin-right: 5%;">{{valor | formaterNumber:0:miles:decimal}}</span>
                              }
                            </td>
                            <td class="w3-center borderAllLow" [ngClass]="'textColorN' + fila.nivel">
                              @if (valor !== null) {
                                <span>{{fila.porcentajes[$index] | formaterNumber:0:miles:decimal}} %</span>
                              }
                            </td>
                          }
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              }
              @if (estructuraCostosA) {
                <h3>{{'financiero.reporte.estructura-costos' | translate}}</h3>
                @if (graficaCostos.data.length > 0) {
                  <div class="zonaGraf zonaGrafCostos">
                    <app-graficador
                      [etiquetas]="true"
                      [porcentaje]="true"
                      [data]="graficaCostos.data"
                      [labels]="graficaCostos.labels"
                      [cascadaTotales]="graficaCostos.totales"
                      [type]="tipoCascada"
                      [axisX]="''"
                      [axisY]="['']"
                      [zona]="zonaCostos"
                      [colors]="colorMulti"
                      [changeLabel]="false"
                      [legend]="legendDona"
                    ></app-graficador>
                  </div>
                }
                @if (!cargandoBalance) {
                  @for (texto of textosCostos; track $index) {
                    <p>@for (parte of partesTexto(texto); track $index) {<span [class.textoNegativo]="parte.negativo">{{parte.texto}}</span>}</p>
                  }
                }
              }
              @if (tendenciaCostosA) {
                <h2 style="margin-top: 2vh;">{{'financiero.reporte.tendencia-costos' | translate}}</h2>
                <p>{{'financiero.reporte.tendencia-costos-def' | translate}}</p>
                @if (graficaTendenciaCostos.data.length > 0) {
                  <div class="zonaGraf zonaGrafAlta">
                    <app-graficador
                      [etiquetas]="true"
                      [porcentaje]="true"
                      [data]="graficaTendenciaCostos.data"
                      [labels]="graficaTendenciaCostos.labels"
                      [type]="tipoApilada"
                      [stackedAbsoluto]="true"
                      [axisX]="''"
                      [axisY]="['']"
                      [zona]="zonaTendenciaCostos"
                      [colors]="colorMulti"
                      [changeLabel]="false"
                      [legend]="legendDona"
                    ></app-graficador>
                  </div>
                }
                @if (!cargandoBalance) {
                  @for (texto of textosTendenciaCostos; track $index) {
                    <p>@for (parte of partesTexto(texto); track $index) {<span [class.textoNegativo]="parte.negativo">{{parte.texto}}</span>}</p>
                  }
                }
              }
            </section>
            <br>
          }

          @if (indicadoresA) {
          <section class="page">
            <div class="pageName">
              {{'financiero.reporte.indicadores-titulo' | translate}}
            </div>
            <p>{{'financiero.reporte.indicadores-intro' | translate}}</p>
            @if (cargandoBalance) {
              <app-skeleton-table [columnas]="4" [filas]="13"/>
            } @else if (bloquesDatos.length > 0) {
              <div class="w3-scroll">
                <table class="w3-table borderInf">
                  <thead style="background-color: #A7A9AC;">
                    <tr class="w3-table-titleBalance">
                      <th class="w3-elemento-titulo-table w3-center w3-border-right-balance">{{'financiero.catalogoCuentas.encabezado2Tabla1' | translate}}</th>
                      @for (limite of columnasLimites; track limite.clave) {
                        <th class="w3-elemento-titulo-table w3-center w3-border-right-balance"><span class="puntoSemaforo" [style.background-color]="limite.color"></span>{{limite.titulo}}</th>
                      }
                    </tr>
                  </thead>
                  <tbody>
                    @for (bloqueDatos of bloquesDatos; track $index) {
                      <tr class="w3-table-trtdBalanceBlue w3-encabezado-balance">
                        <td [attr.colspan]="1 + columnasLimites.length" class="borderAllLow w3-elemento-titulo-tableBalance w3-encabezado-balance">{{bloqueDatos.descripcion | uppercase}}</td>
                      </tr>
                      @for (indicador of bloqueDatos.indicadores; track indicador.id) {
                        <tr class="w3-table-trtdBalance w3-cuerpo-balance">
                          <td class="borderAllLow w3-elemento-tableBalance">
                            <span [style.margin-left.rem]="(indicador.nivel - 2) * 1.2">{{indicador.descripcion}}</span>
                          </td>
                          @for (limite of columnasLimites; track limite.clave) {
                            <td class="w3-center borderAllLow w3-elemento-tableBalance">{{indicador.limites[limite.clave]}}</td>
                          }
                        </tr>
                      }
                    }
                  </tbody>
                </table>
              </div>
            }
            @for (bloque of bloquesIndicadores; track bloque.clave; let i = $index) {
              @if (bloque.activo) {
                <h2 style="margin-top: 2vh;">{{'financiero.reporte.' + bloque.clave | translate}}</h2>
                @if (bloque.definicion) {
                  <p>{{'financiero.reporte.' + bloque.clave + '-def' | translate}}</p>
                }
                @if (!cargandoBalance && bloquesDatos[i]) {
                  <div class="w3-scroll">
                    <table class="w3-table borderInf">
                      <thead style="background-color: #A7A9AC;">
                        <tr class="w3-table-titleBalance">
                          <th class="w3-elemento-titulo-table w3-center w3-border-right-balance">{{'financiero.catalogoCuentas.encabezado2Tabla1' | translate}}</th>
                          @for (limite of columnasLimites; track limite.clave) {
                            <th class="w3-elemento-titulo-table w3-center w3-border-right-balance"><span class="puntoSemaforo" [style.background-color]="limite.color"></span>{{limite.titulo}}</th>
                          }
                          @for (col of columnasBalance; track col.id) {
                            <th class="w3-elemento-titulo-table w3-center w3-border-right-balance">{{col.titulo}}</th>
                          }
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="w3-table-trtdBalanceBlue w3-encabezado-balance">
                          <td [attr.colspan]="1 + columnasLimites.length + columnasBalance.length" class="borderAllLow w3-elemento-titulo-tableBalance w3-encabezado-balance">{{bloquesDatos[i].descripcion | uppercase}}</td>
                        </tr>
                        @for (indicador of bloquesDatos[i].indicadores; track indicador.id) {
                          <tr class="w3-table-trtdBalance w3-cuerpo-balance">
                            <td class="borderAllLow w3-elemento-tableBalance">
                              <span [style.margin-left.rem]="(indicador.nivel - 2) * 1.2">{{indicador.descripcion}}</span>
                            </td>
                            @for (limite of columnasLimites; track limite.clave) {
                              <td class="w3-center borderAllLow w3-elemento-tableBalance">{{indicador.limites[limite.clave]}}</td>
                            }
                            @for (valor of indicador.valores; track $index) {
                              <td class="borderAllLow">
                                <div class="alinRight" [ngClass]="claseSemaforo(valor?.semaforo)">
                                  <span class="w3-elemento-tableBalance" style="margin-right: 1vh;">{{valor?.valor}}</span>
                                </div>
                              </td>
                            }
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                  @for (texto of textosBloques[i]; track $index) {
                    <p>@for (parte of partesTexto(texto); track $index) {<span [class.textoNegativo]="parte.negativo">{{parte.texto}}</span>}</p>
                  }
                }
              }
            }
          </section>
          }
          <br>

          @if (conclusionesA) {
            <section class="page">
              <div class="pageName">
                {{'financiero.reporte.conclusiones-titulo' | translate}}
              </div>
              <mat-form-field appearance="outline" class="zonaTexto" color="warn">
                <mat-label>{{'financiero.reporte.analisis-editor' | translate}}</mat-label>
                <textarea matInput
                  cdkTextareaAutosize
                  cdkAutosizeMinRows="5"
                  cdkAutosizeMaxRows="500"
                  [(ngModel)]="textoConclusiones">
                </textarea>
              </mat-form-field>
            </section>
          }
        </div>
      } @else {
        <div class="preview-background">
          <div class="page">
            <ngx-skeleton-loader count="5" [theme]="{
              'border-radius': '10px',
              height: '2vh',
              width: '50vw',
            }" />
            <ngx-skeleton-loader [theme]="{
              'border-radius': '15px',
              height: '36vh',
              width: '58vw',
            }" />
          </div>
        </div>
      }
    </div>

    <!-- Botón flotante -->
    <div [ngClass]="{'w3-disabled': cargando || descargando || cargandoBalance}">
      <button mat-fab class="fab textoOverFlow" (click)="generarPDF()" [matTooltip]="'financiero.reporte.descargar' | translate">
        <mat-icon>download</mat-icon>
      </button>
    </div>
  </div>
</app-esqueleto-tableros>
